import { useState } from "react";
import "../../../CSS/Mobile.css"
function MobileHome() {
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  return (
    <div className="home">
      <h1 id="name">
        ISAAC JENEMANN
        <span
          className={`home-info-button ${showDropdown ? "active" : ""}`}
          onClick={toggleDropdown}
        >
          &#9432;
        </span>
        <br />
        <div className={`home-dropdown ${showDropdown ? "show" : ""}`}>
          <p>
            is a set designer and filmmaker, occasionally a line cook, and
            always a learner. A background in performance paired with hands-on
            experience in technical direction, carpentry, and lighting design
            informs Isaac’s work and allows a practical approach to using space
            as a storyteller.
            <br />
            <br />
            Please{" "}
            <a className="about-link" href="mailto:isaac.jenemann@gmail.com">
              email
            </a>
            ,{" "}
            <a href="sms:+18028817144" className="about-link">
              text
            </a>
            , or{" "}
            <a className="about-link" href="tel:+18028817144">
              call
            </a>{" "}
            if you're interested in collaborating.
            <br />
            <br />
            References available upon request.
          </p>
          <img
            id="about-image"
            src="./Assets/isaac.jpeg"
            alt="Isaac Jenemann"
          />
        </div>
        <span className={`creative ${showDropdown ? "show" : ""}`}>
          creative
        </span>
      </h1>
    </div>
  );
}

export default MobileHome;
